
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $6f63bcaf2a8b14ee$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["auyDg","index.e43b319b.js","iumYM","star.7cf291c8.svg","6Nnm2","demo-icon.3d87ab8f.svg","3ZoWY","github-code.0d21bbda.svg"]'));

var $0a8e117df5e3101b$exports = {};
$0a8e117df5e3101b$exports = new URL("star.7cf291c8.svg", import.meta.url).toString();


var $70f1fa04ac02da68$exports = {};
$70f1fa04ac02da68$exports = new URL("demo-icon.3d87ab8f.svg", import.meta.url).toString();


var $ede55ca45e12ce4b$exports = {};
$ede55ca45e12ce4b$exports = new URL("github-code.0d21bbda.svg", import.meta.url).toString();


const $2b6e161c9edcf319$var$projectsContainer = document.querySelector(".projects--js");
const $2b6e161c9edcf319$var$username = "bartydash";
const $2b6e161c9edcf319$var$sort = "desc";
console.log("Hello there! Up for a chat? Message me at writetobartek@gmail.com! \uD83D\uDE0A"); //later complete email!- completed
fetch(`https://api.github.com/users/${$2b6e161c9edcf319$var$username}/repos?sort=${$2b6e161c9edcf319$var$sort}`).then((response)=>response.json()).then((response)=>{
    for (let repository of response){
        const { name: name, html_url: html_url, description: description, stargazers_count: stargazers_count, topics: topics, homepage: homepage, fork: fork } = repository;
        let tags = "";
        for (let tag of topics)tags += `<li class="bg-gray-400/10 px-2 py-1 rounded text-sm font-bold">${tag}</li>`;
        const element = `<article class="rounded-round20px bg-gradient-to-br from-white/10 to-white/5 flex flex-col h-full">
        <div
            class="h-11 p-4 flex gap-1.5 shadow-innerlight rounded-t-round20px bg-gradient-to-br from-white/10 to-white/5 ring-1 ring-inset ring-bg">
            <span class="w-3 h-3 block rounded-full bg-bg opacity-50"></span>
            <span class="w-3 h-3 block rounded-full bg-bg opacity-50"></span>
            <span class="w-3 h-3 block rounded-full bg-bg opacity-50"></span>
        </div>
        <div class="p-5 md:p-6 lg:p-10 flex flex-col justify-between grow ring-1 ring-inset ring-bg">
          <div>
            <header class="flex gap-4 items-center mb-4">
                <h3 class="text-2xl leading-none font-bold">${name}</h3>
                <p
                    class="bg-gray-400/10 px-2 py-1 flex gap-0.5 items-center text-gray-400 font-medium leading-none rounded">
                    <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($0a8e117df5e3101b$exports)))}" alt="" class="w-4 h-4">${stargazers_count}
                </p>
            </header>
            <p class="text-gray-400 text-xl mb-4">${description}</p>
            <ul class="flex gap-2 mb-10 flex-wrap">
              ${tags}
            </ul>
          </div>
            <div class="flex flex-col flex-wrap md:flex-row gap-4 items-start">
                <a class="bg-bg text-primary flex gap-2 font-bold py-4 px-5 items-center rounded-round10px md:rounded-xl md:text-xl border-gray-800 border-2 hover:border-primary transition-colors duration-500"
                    href="${homepage}" target="_blank" rel="noopener noreferrer nofollow"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($70f1fa04ac02da68$exports)))}" alt="" class="w-6 h-6">View demo</a>
                <a class="bg-bg text-primary flex gap-2 font-bold py-4 px-5 items-center rounded-round10px md:rounded-xl md:text-xl border-gray-800 border-2 hover:border-primary transition-colors duration-500"
                    href="${html_url}" target="_blank" rel="noopener noreferrer nofollow"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($ede55ca45e12ce4b$exports)))}" alt="" class="w-6 h-6">Source code</a>
            </div>
        </div>
      </article>`;
        if (homepage && !fork && description != null) $2b6e161c9edcf319$var$projectsContainer.insertAdjacentHTML("beforeend", element);
    }
}).catch((e)=>console.log(e));


//# sourceMappingURL=index.e43b319b.js.map
